// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Offers/components/index.css
// module id = 709
// module chunks = 0